import WOW from 'wow.js';

export default class AnimationService {
	static init() {
		return new WOW({ offset: 100 }).init();
	}
}
